import axios from "axios";
import __ from "lodash";
import {getApiSitePrefix} from "./SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const isHTML = (str) => !(str || '')
  .replace(/[\n\r]/g, '')
  // replace html tag with content
  .replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1>/ig, '')
  // remove remaining self closing tags
  .replace(/(<([^>]+)>)/ig, '')
  // remove extra space at start and end
  .trim();


const getTemplate = async (SystemData, modulePath, moduleName, templateType, templateUuid) => {

  try {
    const response = await axios.get(`${apiSitePrefix}/${modulePath}/template/${templateType}/${templateUuid}`);
    if (!response.data) {
      SystemData.alert("Error", `Could not retrieve ${moduleName} Template. Server is not responding`);
      return null;
    } else if (response.data.success) {
      return response.data.template;
    } else {
      SystemData.alert("Error", `Could not retrieve Template. Server returned ${response.data.error}`);
      return null;
    }
  } catch (err) {
    SystemData.alert("Error", `Could not retrieve Template. Server is not responding`);
    return null
  }
}


const getDefaultValues = async (SystemData, modulePath, moduleName) => {

  try {
    const response = await axios.get(`${apiSitePrefix}/${modulePath}/defaults`);
    if (response.data && response.data.success) {
      return response.data.defaultValues;
    }

    if (!response.data) {
      console.log(`Could not retrieve ${moduleName} Defaults. Server is not responding`);
      SystemData.alert("Error", `Could not retrieve ${moduleName} Template. Server is not responding`);
    } else if (!response.data.success) {
      console.log(`Could not retrieve ${moduleName} Defaults. Server returned ${response.data.error}`);
      SystemData.alert("Error", `Could not retrieve ${moduleName} Template. Server returned ${response.data.error}`);
    }
  } catch (err) {
    console.log(`Could not retrieve ${moduleName} Defaults. Server is not responding`);
    SystemData.alert("Error", `Could not retrieve ${moduleName} Template. Server is not responding`);
  }

  return null;
}

const getDefaultValuesWithoutAlert = async (SystemData, modulePath, moduleName) => {

  let message;
  try {
    const response = await axios.get(`${apiSitePrefix}/${modulePath}/defaults`);
    if (response.data && response.data.success) {
      return response.data.defaultValues;
    }

    if (!response.data) {
      message = `Could not retrieve ${moduleName} defaults. Server is not responding`;
      console.log(message);
      throw(message);
    } else if (!response.data.success) {
      message = `Could not retrieve ${moduleName} defaults. Server returned ${response.data.error}`;
      console.log(message);
      throw(message);
    }
  } catch (err) {
    message = `Could not retrieve ${moduleName} Defaults. Server is not responding. ${err}`;
    console.log(err);
    throw(message);
  }

  return null;
}

const getRecipientList = (companyContacts, role, airportCode) => {
  let recipients = [];
  if (companyContacts && Array.isArray(companyContacts)) {
    companyContacts.forEach(contact => {
      if (contact.role === role && (!airportCode || (contact.airportCode === airportCode || contact.airportCode === "" || contact.airportCode === null))) {
        const contactMethods = contact.contactMethods;
        if (contactMethods && Array.isArray(contactMethods)) {
          contactMethods.forEach(method => {
            if (__.has(method, "email")) {
              recipients.push(method.email);
            }
          })
        }
      }
    })
  }
  return recipients.join(", ");
}

const formatDims = (dims) => {
  const dimsList = [];
  if (dims && Array.isArray(dims)) {
    dims.forEach((dim, index) => {
      dimsList.push(`${dim.pieces} piece${Number(dim.pieces) > 1 ? "s" : ""} at ${dim.length} x ${dim.width} x ${dim.height}`);
    });
    return dimsList.join("; ");
  }
}

export {
  isHTML,
  getTemplate,
  getDefaultValues,
  getDefaultValuesWithoutAlert,
  getRecipientList,
  formatDims
}
